<span class="label">
  <span class="label-content">
    <span>{{ label() }}</span>
    <fb-scribe-suggestion-indicator
      [target]="markerTarget()"
      [fieldKey]="markerFieldKey()"
    ></fb-scribe-suggestion-indicator>
    <fb-amendment-field-indicator [rowIndex]="rowIndex()" [fieldKey]="markerFieldKey()" />
  </span>
</span>
<div class="input" [class.is-empty]="!text()" [class.input--multiline]="multiline()">
  <span class="value">{{ text() }}</span>
  @if (showPlaceholder()) {
    <span class="placeholder">{{ placeholder() }}</span>
  }
</div>
